module.exports = __webpack_public_path__ + "images/frontpage_download@1x.png?8afa7ecb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_download@1x.png
// module id = 636
// module chunks = 7